export default __webpack_public_path__ + "static/media/logo1024x1024.eba7a90d.png";